import { render, staticRenderFns } from "./TopSearch.vue?vue&type=template&id=3b05fcea&"
import script from "./TopSearch.vue?vue&type=script&lang=js&"
export * from "./TopSearch.vue?vue&type=script&lang=js&"
import style0 from "./TopSearch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports